console.log("VLN cursor trail script is running");

document.addEventListener('mousemove', function (e) {
  const dot = document.createElement('div');
  dot.className = 'cursor-dot';
  dot.style.position = 'fixed';
  dot.style.top = e.clientY + 'px';
  dot.style.left = e.clientX + 'px';
  dot.style.width = '10px';
  dot.style.height = '10px';
  dot.style.backgroundColor = '#00ffff';
  dot.style.borderRadius = '50%';
  dot.style.pointerEvents = 'none';
  dot.style.zIndex = 9999;
  dot.style.transform = 'translate(-50%, -50%)';
  dot.style.animation = 'fadeOut 0.6s forwards';
  document.body.appendChild(dot);

  setTimeout(() => dot.remove(), 600);
});
